import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import DropDown from '@/components/profile/dropDown'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/bssDetails/constants"
import { useEffect, useState } from 'react';
import { generateYearsObjectsList } from "@/utils"
import '@/pages/profile/sections/common.css'

export default function PassingYear(props: any) {
    const { profile } = useLocalTranslation();
    const [passingYears, setPassingYears] = useState<any>([])

    useEffect(() => {
        generatePassingYears()
    }, [])

    function generatePassingYears() {
        const generateYearsObjectsList_ = generateYearsObjectsList()
        setPassingYears(generateYearsObjectsList_)
    }


    return (
        <div className='profileSectionOfSectionCommonMainCon'>

            <div className='commonCon1'>
                <ul className='list-disc list-inside'>
                    {profile.bssSection.notes.n1.map((n: string, index: number) => (
                        <li key={index}>{n}</li>
                    ))}
                </ul>
            </div>

            <p className='commonH2'>
                {profile.fields.passingYear}
                <span className='text-[#FF2828]'>*</span>
            </p>


            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            <DropDown
                options={passingYears}
                value={props.value}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.passingYear)}
                placeholder={profile.placeHolders.passingYear}
                customDropDownIcon={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.passingYear)}
                />
            </div>
        </div>
    );
}
